/* Copyright (c) 2017 Backpack Health LLC */

import { types as sessionActionTypes } from 'redux/actions/session';
import { authToken } from 'lib/storagePolyfill';
import AccessTokenModel, { accessTokenTypes } from 'models/AccessTokenModel';

const initialState = {
  loginVerified: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case sessionActionTypes.LOG_OUT:
    case sessionActionTypes.LOG_IN_SUCCESSFUL:
      return Object.assign({}, state, action.payload);
    case sessionActionTypes.LOG_IN:
    default:
      return state;
  }
}

const selectors = {
  isLoggedIn: state => {
    const token = authToken.get();
    const accessToken = AccessTokenModel.createFromAuthToken(token);
    return accessToken.isLoggedIn();
  },
  requiresMfa: state => {
    if (!authToken.get()) { return false; }
    return authToken.decode().type === accessTokenTypes.MFA;
  }
};

export default selectors;
